import React from "react";
import { Link, NavLink } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useCart } from "@/lib/CartContext";
import CartDrawer from "@/components/CartDrawer";
import VituraAnimatedLogo from "@/components/VituraAnimatedLogo";

const links = [
  { to: "/preview/shop", label: "Shop" },
  { to: "/story", label: "Story" },
  { to: "/journal", label: "Journal" },
];

export default function Navbar() {
  const { cart, setOpen } = useCart();
  const [mobile, setMobile] = React.useState(false);
  const count = cart?.count || 0;

  return (
    <header className="sticky top-0 z-40 border-b border-[color:var(--line)] bg-[color:var(--bg)]/80 backdrop-blur-xl" data-testid="site-header">
      <div className="max-w-site mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <button
          className="md:hidden p-2 -ml-2"
          aria-label="Open menu"
          data-testid="nav-mobile-toggle"
          onClick={() => setMobile((v) => !v)}
        >
          {mobile ? <X size={18} /> : <Menu size={18} />}
        </button>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `label !tracking-[0.22em] text-[#0f0f10] hover:text-[#6b6b6b] transition ${isActive ? "opacity-100" : "opacity-80"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <Link to="/preview" className="flex items-center gap-2" data-testid="nav-home-logo">
          <VituraAnimatedLogo color="#0f0f10" width={130} />
        </Link>

        <div className="flex items-center gap-5">
          <Link to="/preview/account" className="hidden md:block label" data-testid="nav-account">Account</Link>
          <button
            onClick={() => setOpen(true)}
            className="relative flex items-center gap-2 label"
            aria-label="Open cart"
            data-testid="nav-cart-button"
          >
            <ShoppingBag size={16} />
            <span className="hidden sm:inline">Bag</span>
            <span
              className="absolute -top-2 -right-3 min-w-[16px] h-[16px] px-1 text-[10px] text-[#faf9f5] bg-[#0f0f10] flex items-center justify-center"
              data-testid="nav-cart-count"
            >
              {count}
            </span>
          </button>
        </div>
      </div>

      {mobile && (
        <div className="md:hidden border-t border-[color:var(--line)] px-6 py-4 flex flex-col gap-4 bg-[color:var(--bg)]">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setMobile(false)}
              className="label"
              data-testid={`nav-mobile-${l.label.toLowerCase()}`}
            >
              {l.label}
            </Link>
          ))}
          <Link to="/preview/account" onClick={() => setMobile(false)} className="label" data-testid="nav-mobile-account">Account</Link>
        </div>
      )}

      <CartDrawer />
    </header>
  );
}
